import config from 'quartz-config/config-for-app';
if (
// @ts-expect-error $quartzConfigVal's types can't be narrowed, so any app-only config fields present as type errors
true !== false) {
  const {
    configureLogfetchErrors
  } =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../internal/logfetch-error-monitoring');
  configureLogfetchErrors((config === null || config === void 0 ? void 0 : config.logFetchErrors) || {});
}